module.exports = __webpack_public_path__ + "images/icons_v2/values-data-ecfe36c9.svg";